var map = {
	"./category-biosphere.jpg": 56377,
	"./category-climate.jpg": 75765,
	"./category-energy.jpg": 55946,
	"./category-food.jpg": 34158,
	"./category-health.jpg": 32784,
	"./category-land.jpg": 1841,
	"./category-materials.jpg": 70454,
	"./category-water.jpg": 79877
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53524;